import { BrandedLogo } from "@components:BrandedLogo";
import { Box, CircularProgress } from "@mui/material";

/**
 * Animated loading screen with logo
 * Shows during app initialization (auth + bot loading)
 * Circular spinner around logo, blurred background
 */
export const LoadingScreen = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        height: "100vh",
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(10px)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress
          size={140}
          thickness={2}
          sx={{
            color: "primary.main",
            position: "absolute",
          }}
        />
        <BrandedLogo
          sx={{
            maxWidth: 80,
            maxHeight: 50,
            zIndex: 1,
          }}
        />
      </Box>
    </Box>
  );
};
